import * as angular from "angular";
import {IController} from "angular";

export class OrderFulfillmentLinesListItemCtrl implements IController {

  fulfillmentLine:any;
  isSelectedLine:boolean;
  lineIndex:number;
  order:any;
  onSelect:Function;
}

angular
  .module('bringoz.admin.fulfillment')
  .component('orderFulfillmentLinesListItem', {
    bindings: {
      fulfillmentLine:'<',
      isSelectedLine:'<',
      lineIndex:'<',
      order:'<',
      onSelect: '&'

    },
    template: require('./order-fulfillment-lines-list-item.html').default,
    controller: OrderFulfillmentLinesListItemCtrl
  });
